import { ChangeEvent, useEffect, useState } from "react";
import { useUserInfor } from "../../../../../Context/User";
import { IClienteCompleto } from "../../../../../Interfaces/Geral/Cliente/IClienteSimples";
import {
    FormatterCEP,
    FormatterCPF,
} from "../../../../../Validations/InputMasks";
import ModalComponent from "../../../../Modais";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import EditarCliente from "./EditarCliente";
import { GetCidadePorIdController } from "../../../../../Controllers/Geral/Endereco/Cidade/CidadeControllers";
import { ListarEstadoPorIdController } from "../../../../../Controllers/Geral/Endereco/Estado/EstadoControllers";

interface IDadosCadastraisClienteProps {
    Cliente?: IClienteCompleto;
}

export default function DadosCadastraisCliente(
    props: IDadosCadastraisClienteProps
) {
    const { FUNCOES } = useUserInfor().UserInfor;
    const { OrgInfor } = useUserInfor();

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [mostrarUAU, setmostrarUAU] = useState(false);

    const [cidadeCobranca, setCidadeCobranca] = useState("");
    const [estadoCobranca, setEstadoCobranca] = useState("");
    const [cidadeEntrega, setCidadeEntrega] = useState("");
    const [estadoEntrega, setEstadoEntrega] = useState("");

    useEffect(() => {
        if (props.Cliente?.ID_CIDADE_COBRANCA) {
            GetCidadePorIdController(props.Cliente.ID_CIDADE_COBRANCA).then(
                (res) => {
                    setCidadeCobranca(res.DS_CIDADE);
                    ListarEstadoPorIdController(res.ID_ESTADO).then((res) => {
                        setEstadoCobranca(res.DS_ESTADO);
                    });
                }
            );
        }

        if (props.Cliente?.ID_CIDADE_ENTREGA) {
            GetCidadePorIdController(props.Cliente.ID_CIDADE_ENTREGA).then(
                (res) => {
                    setCidadeEntrega(res.DS_CIDADE);
                    ListarEstadoPorIdController(res.ID_ESTADO).then((res) => {
                        setEstadoEntrega(res.DS_ESTADO);
                    });
                }
            );
        }
    }, [props.Cliente]);

    const Cliente: IClienteCompleto | undefined =
        mostrarUAU && props.Cliente?.DADOS_CLIENTE
            ? {
                  NR_CPF: props.Cliente?.DADOS_CLIENTE?.cpf_pes,
                  DS_NOME: props.Cliente?.DADOS_CLIENTE?.nome_pes,
                  DS_EMAIL: props.Cliente?.DADOS_CLIENTE?.email_pes,
                  DT_NASCIMENTO: props.Cliente?.DADOS_CLIENTE?.dtnasc_pes,
                  DS_ESTADO_CIVIL: props.Cliente?.DADOS_CLIENTE?.estciv_pf,
                  NR_ENDERECO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.numend_pend,
                  DS_ESTADO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.uf_pend,
                  DS_CIDADE_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.cidade_pend,
                  DS_BAIRRO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.bairro_pend,
                  DS_LOGRADOURO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.endereco_pend,
                  DS_COMPLEMENTO_COBRANCA:
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca
                          ?.complendereco_pend,
                  NR_ENDERECO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.numend_pend,
                  DS_ESTADO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.uf_pend,
                  DS_CIDADE_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.cidade_pend,
                  DS_BAIRRO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.bairro_pend,
                  DS_LOGRADOURO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.endereco_pend,
                  DS_COMPLEMENTO_ENTREGA:
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega
                          ?.complendereco_pend,
                  NR_CEP_COBRANCA: Number(
                      props.Cliente?.DADOS_CLIENTE?.EndCobranca?.cep_pend
                  ),
                  NR_CEP_ENTREGA: Number(
                      props.Cliente?.DADOS_CLIENTE?.EndEntrega?.cep_pend
                  ),
              }
            : props.Cliente;

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setmostrarUAU(e.target.checked);
    }

    return (
        <>
            <div className="d-flex card card-custom card-stretch">
                <div className="card-header">
                    <div className="d-flex flex-column mt-4">
                        <h3 className="card-title">Dados Cadastrais</h3>
                        {props.Cliente?.DADOS_CLIENTE &&
                            OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                                <div className="d-flex text-success align-items-center mr-2">
                                    <label htmlFor="mostrardadosUAUcheckbox">
                                        {" "}
                                        Mostrar Dados UAU
                                    </label>
                                    <input
                                        className="ml-2 mb-2 "
                                        type={"checkbox"}
                                        id={"mostrardadosUAUcheckbox"}
                                        onChange={handleChange}
                                        checked={mostrarUAU}
                                    />
                                </div>
                            )}
                    </div>
                    <div className="card-toolbar">
                        <ModalComponent
                            show={show}
                            setShow={setShow}
                            ModalComponent={modal}
                        />
                        {!FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_BLOQUEAR_EDICAO_CONTAS"
                        ) && (
                            <button
                                type="button"
                                className="btn btn-sm btn-success font-weight-bold"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Dados Cadastrais",

                                        Component: () => (
                                            <EditarCliente
                                                Cliente={props.Cliente}
                                                setShow={setShow}
                                            />
                                        ),
                                        scrollable: true,
                                        size: "xl",
                                    });
                                }}
                            >
                                <i className="flaticon-edit"></i> Editar
                            </button>
                        )}
                    </div>
                </div>
                <div className="card-body pt-4">
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            {Cliente?.DS_IMOVEL_PROPRIO === "Sim" ? (
                                <span
                                    className="svg-icon svg-icon-lg svg-icon-gray-500 mr-4"
                                    title="Cliente possue imovel proprio"
                                >
                                    <i className="fas fa-house-user"></i>
                                </span>
                            ) : (
                                <></>
                            )}
                            {Cliente?.DS_VEICULO_PROPRIO === "Sim" ? (
                                <span
                                    className="svg-icon svg-icon-lg svg-icon-gray-500 mr-4"
                                    title="Cliente possue Veiculo proprio"
                                >
                                    <i className="fas fa-car"></i>
                                </span>
                            ) : (
                                <></>
                            )}
                            <div className="font-weight-bolder font-size-h5 text-dark-75 ">
                                {Cliente?.DS_SAUDACAO} {Cliente?.DS_NOME}
                                {props.Cliente?.tipoConta
                                    ?.DS_PERFIL_TIPO_CONTA ? (
                                    <>
                                        {" "}
                                        |
                                        <i
                                            style={{
                                                color: props.Cliente?.tipoConta
                                                    ?.HX_COR_PERFIL_TIPO_CONTA,
                                            }}
                                            className={`${props.Cliente?.tipoConta?.DS_ICON_PERFIL_TIPO_CONTA}`}
                                        ></i>{" "}
                                        <span>
                                            {
                                                props.Cliente?.tipoConta
                                                    ?.DS_PERFIL_TIPO_CONTA
                                            }
                                        </span>
                                    </>
                                ) : null}
                            </div>
                            <label className="text-muted">
                                {Cliente?.DS_EMAIL}
                            </label>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap align-items-center justify-content-between mt-3">
                        <span
                            className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2 pb-3"
                            title="CPF"
                        >
                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                <i className="far fa-address-card"></i>
                            </span>
                            {FormatterCPF(Cliente?.NR_CPF?.toString() || "") ||
                                "Sem Informação"}
                        </span>
                        <span
                            className="d-flex align-items-center text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 pb-3"
                            title="RG"
                        >
                            <span className="svg-icon svg-icon-lg svg-icon-gray-500 mr-4">
                                <i className="fab fa-500px"></i>
                            </span>
                            {Cliente?.NR_RG?.toString() || "Sem Informação"}
                        </span>

                        <span
                            className="d-flex align-items-center text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 pb-3"
                            title="Perfil Financeiro"
                        >
                            <span className="svg-icon svg-icon-lg svg-icon-gray-500 mr-4">
                                <i className="far fa-gem"></i>
                            </span>
                            {props.Cliente?.perfilFinanceiro
                                ?.DS_PERFIL_FINANCEIRO_CONTA ||
                                "Sem Informação"}
                        </span>

                        <span
                            className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 pb-3"
                            title="Sexo"
                        >
                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                <i className="fas fa-restroom"></i>
                            </span>
                            {Cliente?.DS_SEXO?.toString() || "Sem Informação"}
                        </span>
                        <span
                            className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 pb-3"
                            title="Estado Civil"
                        >
                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                <i className="fas fa-ring"></i>
                            </span>
                            {Cliente?.DS_ESTADO_CIVIL?.toString() ||
                                "Sem Informação"}
                        </span>
                        <span
                            className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 pb-3"
                            title="Data de Nascimento"
                        >
                            <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                <i className="fas fa-calendar-day"></i>
                            </span>
                            {Cliente?.DT_NASCIMENTO
                                ? new Date(
                                      Cliente?.DT_NASCIMENTO
                                  ).toLocaleDateString()
                                : "Sem Informação"}
                        </span>
                    </div>
                    <div className="py-3">
                        <label className="text-muted text-dark-75 font-weight-bold font-size-h6">
                            Informações Extras
                        </label>
                        <div className="d-flex flex-column">
                            <label className="text-muted mr-3">
                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                    <i className="fas fa-chess-king"></i>
                                </span>
                                {Cliente?.DS_NOME_PAI ?? "Sem Informação"} - Pai
                            </label>
                            <label className="text-muted">
                                <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                    <i className="fas fa-chess-queen"></i>
                                </span>
                                {Cliente?.DS_NOME_MAE ?? "Sem Informação"} - Mãe
                            </label>
                        </div>
                    </div>
                    <div>
                        <label className="text-muted text-dark-75 font-weight-bold font-size-h6">
                            Endereços
                        </label>
                        <ul className="nav nav-light-dark nav-bold nav-pills mb-3">
                            <li className="nav-item">
                                <a
                                    className="nav-link active"
                                    data-toggle="tab"
                                    href="#EnderecoCobranca"
                                >
                                    <span className="nav-icon">
                                        <i className="flaticon2-chat-1"></i>
                                    </span>
                                    <span className="nav-text">Cobrança</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    data-toggle="tab"
                                    href="#EnderecoEntrega"
                                >
                                    <span className="nav-icon">
                                        <i className="flaticon2-drop"></i>
                                    </span>
                                    <span className="nav-text">Entrega</span>
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div
                                className="tab-pane fade active show"
                                id="EnderecoCobranca"
                                role="tabpanel"
                            >
                                <div className="d-flex align-items-center wave wave-animate-slow wave-warning rounded justify-content-evenly">
                                    <div className="svg-icon svg-icon-warning">
                                        <span className="svg-icon svg-icon-primary svg-icon-4x">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <rect
                                                        x="0"
                                                        y="0"
                                                        width="24"
                                                        height="24"
                                                    />
                                                    <path
                                                        d="M6,2 L18,2 C19.6568542,2 21,3.34314575 21,5 L21,19 C21,20.6568542 19.6568542,22 18,22 L6,22 C4.34314575,22 3,20.6568542 3,19 L3,5 C3,3.34314575 4.34314575,2 6,2 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M7.00036205,16.4995035 C6.98863236,16.6619875 7.26484009,17 7.4041679,17 C11.463736,17 14.5228466,17 16.5815,17 C16.9988413,17 17.0053266,16.6221713 16.9988413,16.5 C16.8360465,13.4332455 14.6506758,12 11.9907452,12 C9.36772908,12 7.21569918,13.5165724 7.00036205,16.4995035 Z"
                                                        fill="#000000"
                                                    />
                                                </g>
                                            </svg>
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <label className="mb-0">
                                            Estado -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_ESTADO_COBRANCA ||
                                                    estadoCobranca ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>
                                        <label className="mb-0">
                                            Cidade -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_CIDADE_COBRANCA ||
                                                    cidadeCobranca ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>
                                        <label className="mb-0">
                                            Bairro -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_BAIRRO_COBRANCA ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>

                                        <label className="mb-0">
                                            {Cliente?.DS_LOGRADOURO_COBRANCA ||
                                                "Sem Informação"}{" "}
                                            -
                                            <label className="pl-2 pr-2">
                                                Nº{" "}
                                                {Cliente?.NR_ENDERECO_COBRANCA ||
                                                    "Sem Informação"}
                                            </label>
                                            CEP{" "}
                                            {!mostrarUAU
                                                ? FormatterCEP(
                                                      Cliente?.NR_CEP_COBRANCA?.toString() ||
                                                          ""
                                                  ) || "Sem Informação"
                                                : FormatterCEP(
                                                      props.Cliente
                                                          ?.DADOS_CLIENTE
                                                          ?.EndCobranca
                                                          ?.cep_pend || ""
                                                  ) || "Sem Informação"}
                                        </label>
                                        <label className="mb-0 text-dark-75">
                                            Complemento -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_COMPLEMENTO_COBRANCA ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="EnderecoEntrega"
                                role="tabpanel"
                            >
                                <div className="d-flex align-items-center wave wave-animate-slow wave-primary rounded justify-content-evenly">
                                    <div className="svg-icon svg-icon-primary">
                                        <span className="svg-icon svg-icon-primary svg-icon-4x">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <rect
                                                        x="0"
                                                        y="0"
                                                        width="24"
                                                        height="24"
                                                    />
                                                    <path
                                                        d="M6,2 L18,2 C19.6568542,2 21,3.34314575 21,5 L21,19 C21,20.6568542 19.6568542,22 18,22 L6,22 C4.34314575,22 3,20.6568542 3,19 L3,5 C3,3.34314575 4.34314575,2 6,2 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M7.00036205,16.4995035 C6.98863236,16.6619875 7.26484009,17 7.4041679,17 C11.463736,17 14.5228466,17 16.5815,17 C16.9988413,17 17.0053266,16.6221713 16.9988413,16.5 C16.8360465,13.4332455 14.6506758,12 11.9907452,12 C9.36772908,12 7.21569918,13.5165724 7.00036205,16.4995035 Z"
                                                        fill="#000000"
                                                    />
                                                </g>
                                            </svg>
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <label className="mb-0">
                                            Estado -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_ESTADO_ENTREGA ||
                                                    estadoEntrega ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>
                                        <label className="mb-0">
                                            Cidade -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_CIDADE_ENTREGA ||
                                                    cidadeEntrega ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>
                                        <label className="mb-0">
                                            Bairro -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_BAIRRO_ENTREGA ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>

                                        <label className="mb-0">
                                            {Cliente?.DS_LOGRADOURO_ENTREGA ||
                                                "Sem Informação"}{" "}
                                            -
                                            <label className="pl-2 pr-2">
                                                Nº{" "}
                                                {Cliente?.NR_ENDERECO_ENTREGA ||
                                                    "Sem Informação"}
                                            </label>
                                            CEP{" "}
                                            {!mostrarUAU
                                                ? FormatterCEP(
                                                      Cliente?.NR_CEP_ENTREGA?.toString() ||
                                                          ""
                                                  ) || "Sem Informação"
                                                : FormatterCEP(
                                                      props.Cliente
                                                          ?.DADOS_CLIENTE
                                                          ?.EndEntrega
                                                          ?.cep_pend || ""
                                                  ) || "Sem Informação"}
                                        </label>
                                        <label className="mb-0 text-dark-75">
                                            Complemento -
                                            <label className="pl-1 text-dark-50 font-weight-bold text-hover-dark">
                                                {Cliente?.DS_COMPLEMENTO_ENTREGA ||
                                                    "Sem Informação"}
                                            </label>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
